module.exports = __webpack_public_path__ + "static/media/arrowDown.989e3f15.svg";